<app-admin-list-page [title]="'Follow-up days' | translate">

  <app-table [config]="configTable"></app-table>

</app-admin-list-page>
